var path = '/static/assets/khapps/lab/assessments/assessment_detail/AssessmentDetail.html';
var html = "<kh-card cards=\"AssessmentDetailCards\"></kh-card>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;